var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransactions = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.025 21.95C8.45833 21.7 6.31666 20.625 4.59999 18.725C2.88333 16.825 2.02499 14.5833 2.02499 12C2.02499 9.41667 2.88333 7.175 4.59999 5.275C6.31666 3.375 8.45833 2.3 11.025 2.05V5.05C9.29166 5.28334 7.85833 6.05834 6.72499 7.375C5.59166 8.69167 5.02499 10.2333 5.02499 12C5.02499 13.7667 5.59166 15.3083 6.72499 16.625C7.85833 17.9417 9.29166 18.7167 11.025 18.95V21.95ZM13.025 21.95V18.95C14.5917 18.75 15.9167 18.1 17 17C18.0833 15.9 18.7417 14.5667 18.975 13H21.975C21.7417 15.3833 20.7875 17.4125 19.1125 19.0875C17.4375 20.7625 15.4083 21.7167 13.025 21.95ZM18.975 11C18.7417 9.43334 18.0833 8.1 17 7C15.9167 5.9 14.5917 5.25 13.025 5.05V2.05C15.4083 2.28334 17.4375 3.2375 19.1125 4.9125C20.7875 6.5875 21.7417 8.61667 21.975 11H18.975Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransactions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transactions.8698394c068bc9e262a2b70bf5089dd0.svg";